<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <br />
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-img :src="image" class="image" alt="Siding Image" left></v-img>
        </v-row>
        <v-row>
          <p>
            {{ get("p-1.1") }}
          </p>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <h2>{{ get("header-2") }}</h2>
          <p>
            {{ get("p-2.1") }}
          </p>
          <ul>
            <li>{{ get("p-2.2") }}</li>
            <li>{{ get("p-2.3") }}</li>
            <li>
              {{ get("p-2.4") }}
            </li>
          </ul>
          <p>
            {{ get("p-2.5") }}
          </p>
        </v-row>
        <h2>{{ get("header-3") }}</h2>
        <p>
          {{ get("p-3.1") }}
        </p>
        <p>
          {{ get("p-3.2") }}
        </p>
        <h2>{{ get("header-4") }}</h2>
        <p>
          {{ get("p-4.1") }}
           <phonenumber phone="(719) 390-7663"></phonenumber> 
           {{ get("p-4.2") }}
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
    <v-row>
        <v-col col="12" xl="4" lg="4" md="4" sm="12">
            <v-img :src="image2" class="image" alt="Siding Image" left></v-img>
        </v-col>
        <v-col col="12" xl="4" lg="4" md="4" sm="12">
            <v-img :src="image3" class="image" alt="Siding Image" left></v-img>
        </v-col>
        <v-col col="12" xl="4" lg="4" md="4" sm="12">
            <v-img :src="image4" class="image" alt="Siding Image" left></v-img>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "siding-home",

  components: {
    estimate,
    phonenumber
  },

  created() {
    this.pageName = "siding";
  },


  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  data: () => ({
    image: require("@/assets/siding-1.jpg"),
    image2: require("@/assets/siding-2.jpg"),
    image3: require("@/assets/siding-3.jpg"),
    image4: require("@/assets/siding-4.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>

.image {
  margin-bottom: 20px;
}
</style>
